export const DEPOSIT = '/deposit';
export const DEPOSIT_CARD = `${ DEPOSIT }/card`;
export const DEPOSIT_BANK = `${ DEPOSIT }/bank`;
export const DEPOSIT_CRYPTO = `${ DEPOSIT }/crypto`;
export const DEPOSIT_COIN = `${ DEPOSIT_CRYPTO }/:code`;

export const PAYMENT_METHOD = '/payment-method';
export const PAYMENT_METHOD_BANK = `${ PAYMENT_METHOD }/bank`;
export const PAYMENT_METHOD_CRYPTO = `${ PAYMENT_METHOD }/crypto`;
